import type React from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const SimulateIcon: React.FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props} viewBox="0 0 16 17">
    <path d="M3 2C2.44772 2 2 2.44772 2 3V5.5C2 6.05228 2.44772 6.5 3 6.5H3.5V7.39645C3.5 8.06462 4.30785 8.39925 4.78033 7.92678L6.20711 6.5H9.5C10.0523 6.5 10.5 6.05228 10.5 5.5V3C10.5 2.44772 10.0523 2 9.5 2H3ZM3 3H9.5V5.5H6.10355C5.90464 5.5 5.71388 5.57902 5.57322 5.71967L4.5 6.79289V6.25C4.5 5.83579 4.16421 5.5 3.75 5.5H3V3Z" />
    <path d="M13 8C13.5523 8 14 8.44772 14 9V11.5C14 12.0523 13.5523 12.5 13 12.5H12.5V13.3964C12.5 14.0646 11.6921 14.3993 11.2197 13.9268L9.79289 12.5H6.5C5.94772 12.5 5.5 12.0523 5.5 11.5V9C5.5 8.44772 5.94772 8 6.5 8H13ZM13 9H6.5V11.5H9.89645C10.0954 11.5 10.2861 11.579 10.4268 11.7197L11.5 12.7929V12.25C11.5 11.8358 11.8358 11.5 12.25 11.5H13V9Z" />
  </BaseIcon>
);
